export default {
  FETCH_LVM_SALES_REQUEST: 'FETCH_LVM_SALES_REQUEST',
  FETCH_LVM_SALES_SUCCESS: 'FETCH_LVM_SALES_SUCCESS',
  FETCH_LVM_SALES_FAILURE: 'FETCH_LVM_SALES_FAILURE',

  FETCH_LVM_SALES_HISTORY_REQUEST: 'FETCH_LVM_SALES_HISTORY_REQUEST',
  FETCH_LVM_SALES_HISTORY_SUCCESS: 'FETCH_LVM_SALES_HISTORY_SUCCESS',
  FETCH_LVM_SALES_HISTORY_FAILURE: 'FETCH_LVM_SALES_HISTORY_FAILURE',

  DOWNLOAD_LVM_SALES_HISTORY_REPORT_REQUEST: 'DOWNLOAD_LVM_SALES_HISTORY_REPORT_REQUEST',
  DOWNLOAD_LVM_SALES_HISTORY_REPORT_SUCCESS: 'DOWNLOAD_LVM_SALES_HISTORY_REPORT_SUCCESS',
  DOWNLOAD_LVM_SALES_HISTORY_REPORT_FAILURE: 'DOWNLOAD_LVM_SALES_HISTORY_REPORT_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/lvm-sales-history/action-types.js